import { FieldState } from 'formstate'
import { DeepReadonly } from '../../../../helpers/general-helpers'

type AppCustomizationField = {
  backendKey?: string
  frontendKey: string
  i18nKey: string
  isBoolean: boolean
  isHomepass?: boolean
  isWorkpass?: boolean
  requiredKey?: string
  homepassCloudVersionRange?: string
  workpassCloudVersionRange?: string
  isAdvanced?: boolean
  frontendDefault?: string | boolean
  customRender?: 'start' | 'continuation'
}

const appCustomizationAllFieldsSource = [
  {
    backendKey: 'privacyLink',
    frontendKey: 'urlPrivacyPolicy',
    i18nKey: 'privacyPolicyUrl',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
  },
  {
    backendKey: 'termsLink',
    frontendKey: 'urlTemsOfUse',
    i18nKey: 'termsOfServiceUrl',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
  },
  {
    backendKey: 'faqEnabled',
    frontendKey: 'faqEnabled',
    i18nKey: 'provideFaqLink',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '<1.135.0',
  },
  {
    backendKey: 'faqLink',
    frontendKey: 'urlFaq',
    i18nKey: 'faqUrl',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'faqEnabled',
  },
  {
    // Not used in CSC
    backendKey: 'buyPodEnabled',
    frontendKey: 'buyPodEnabled',
    i18nKey: 'allowPodPurchase',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    customRender: 'start',
    homepassCloudVersionRange: '<1.140.0',
  },
  {
    backendKey: 'getPartnerBuyPodUrl',
    frontendKey: 'urlPartnerBuyPod',
    i18nKey: 'purchasePodUrl',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'buyPodEnabled',
    customRender: 'continuation',
  },
  // // only used for backend payload
  // {
  //   backendKey: 'usePartnerBuyPodUrl',
  //   frontendKey: 'partnerBuyPodUrlEnabled',
  //   isBoolean: true,
  //   isHomepass: true,
  //   isWorkpass: true,
  //   homepassCloudVersionRange: '<1.135.0',
  // },
  {
    backendKey: 'addPodEnabled',
    frontendKey: 'addPodEnabled',
    i18nKey: 'allowAddPods',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
  },
  {
    backendKey: 'removePodEnabled',
    frontendKey: 'removePodEnabled',
    i18nKey: 'allowRemovePods',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
  },
  {
    // Not used in CSC
    backendKey: 'contactUsEnabled',
    frontendKey: 'contactUsEnabled',
    i18nKey: 'showSupportEmail',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '<1.135.0',
  },
  {
    backendKey: 'contactUsEmail',
    frontendKey: 'contactUsEmail',
    i18nKey: 'emailSupportUse',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'contactUsEnabled',
  },
  {
    // Not used in CSC
    backendKey: 'callUsEnabled',
    frontendKey: 'callUsEnabled',
    i18nKey: 'showPhoneNumber',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '<1.135.0',
  },
  {
    backendKey: 'callUsDisplayNumber',
    frontendKey: 'callUsDisplayNumber',
    i18nKey: 'displayPhoneNumForSuupport',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'callUsEnabled',
  },
  {
    backendKey: 'callUsNumber',
    frontendKey: 'callUsNumber',
    i18nKey: 'phoneNumForSuupport',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'callUsEnabled',
  },

  {
    backendKey: 'manageAccountEnabled',
    frontendKey: 'manageAccountEnabled',
    i18nKey: 'manageAccountEnabled',
    isBoolean: true,
    isHomepass: true,
    isAdvanced: true,
    customRender: 'start',
    homepassCloudVersionRange: '<1.140.0',
  },
  {
    backendKey: 'getPartnerAccountUrl',
    frontendKey: 'getPartnerAccountUrl',
    i18nKey: 'getPartnerAccountUrl',
    isBoolean: false,
    isHomepass: true,
    // requiredKey: 'manageAccountEnabled', // because more complex use of requiredKey, will do custom logic
    isAdvanced: true,
    customRender: 'continuation',
  },
  {
    backendKey: 'usePartnerAccountUrl',
    frontendKey: 'usePartnerAccountUrl',
    i18nKey: '',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '<1.135.0',
    isAdvanced: true,
    frontendDefault: true,
    customRender: 'continuation',
  },
  {
    backendKey: 'captivePortalDefaultLoginOptions',
    frontendKey: 'captivePortalDefaultLoginOptions',
    i18nKey: 'captivePortalLoginOptions',
    isBoolean: false,
    isWorkpass: true,
    workpassCloudVersionRange: '>=1.124.0',
    isAdvanced: true,
    frontendDefault: 'email',
    customRender: 'start',
  },
  // not shown on app customization modal, only used in mice-backend logic
  // {
  //   backendKey: 'privacyEnabled',
  //   frontendKey: 'privacyEnabled',
  //   i18nKey: '',
  //   isBoolean: true,
  //   isWorkpass: true,
  //   isAdvanced: true,
  //   homepassCloudVersionRange: '<1.140.0',
  // },
  // {
  //   backendKey: 'termsEnabled',
  //   frontendKey: 'termsEnabled',
  //   i18nKey: '',
  //   isBoolean: true,
  //   isWorkpass: true,
  //   isAdvanced: true,
  //   homepassCloudVersionRange: '<1.140.0',
  // },
  {
    backendKey: 'removeGatewayEnabled',
    frontendKey: 'removeGatewayEnabled',
    i18nKey: 'removeGatewayEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    isAdvanced: true,
  },
  {
    backendKey: 'manageYourDataEnabled',
    frontendKey: 'manageYourDataEnabled',
    i18nKey: 'manageYourDataEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    isAdvanced: true,
    homepassCloudVersionRange: '<1.140.0',
  },
  {
    backendKey: 'manageYourDataUrl',
    frontendKey: 'manageYourDataUrl',
    i18nKey: 'manageYourDataUrl',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'manageYourDataEnabled',
    isAdvanced: true,
  },
  {
    backendKey: 'hideIspNameEnabled',
    frontendKey: 'hideIspNameEnabled',
    i18nKey: 'hideIspNameEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    isAdvanced: true,
  },
  {
    backendKey: 'multilocationEnabled',
    frontendKey: 'multilocationEnabled',
    i18nKey: 'multilocationEnabled',
    isBoolean: true,
    isHomepass: true,
    isAdvanced: true,
  },
  {
    backendKey: 'autorunSpeedtestToggleEnabled',
    frontendKey: 'autorunSpeedtestToggleEnabled',
    i18nKey: 'autorunSpeedtestToggleEnabled',
    isBoolean: true,
    isHomepass: true,
    isAdvanced: true,
  },
  {
    backendKey: 'chatSupportEnabled',
    frontendKey: 'chatSupportEnabled',
    i18nKey: 'chatSupportEnabled',
    isBoolean: true,
    isHomepass: true,
    isAdvanced: true,
    homepassCloudVersionRange: '<1.140.0',
  },
  {
    backendKey: 'chatSupportUrl',
    frontendKey: 'chatSupportUrl',
    i18nKey: 'chatSupportUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'chatSupportEnabled',
    isAdvanced: true,
  },
  {
    frontendKey: 'adaptOnlyPurchaseUrlEnabled',
    i18nKey: 'adaptOnlyPurchaseUrlEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'adaptOnlyPurchaseUrl',
    frontendKey: 'adaptOnlyPurchaseUrl',
    i18nKey: 'adaptOnlyPurchaseUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'adaptOnlyPurchaseUrlEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'legalUrlEnabled',
    i18nKey: 'legalUrlEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'legalUrl',
    frontendKey: 'legalUrl',
    i18nKey: 'legalUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'legalUrlEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'nodeSelectionGuideUrlEnabled',
    i18nKey: 'nodeSelectionGuideUrlEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'nodeSelectionGuideUrl',
    frontendKey: 'nodeSelectionGuideUrl',
    i18nKey: 'nodeSelectionGuideUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'nodeSelectionGuideUrlEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'removeResidentialGatewayEnabled',
    frontendKey: 'removeResidentialGatewayEnabled',
    i18nKey: 'removeResidentialGatewayEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'supportedGatewaysUrlEnabled',
    i18nKey: 'supportedGatewaysUrlEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'supportedGatewaysUrl',
    frontendKey: 'supportedGatewaysUrl',
    i18nKey: 'supportedGatewaysUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'supportedGatewaysUrlEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'trademarksLinkEnabled',
    i18nKey: 'trademarksLinkEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'trademarksLink',
    frontendKey: 'trademarksLink',
    i18nKey: 'trademarksLink',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'trademarksLinkEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'verifyWifiInformationUrlEnabled',
    i18nKey: 'verifyWifiInformationUrlEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'verifyWifiInformationUrl',
    frontendKey: 'verifyWifiInformationUrl',
    i18nKey: 'verifyWifiInformationUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'verifyWifiInformationUrlEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'wpa3LimitedMoreInfoUrlEnabled',
    i18nKey: 'wpa3LimitedMoreInfoUrlEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'wpa3LimitedMoreInfoUrl',
    frontendKey: 'wpa3LimitedMoreInfoUrl',
    i18nKey: 'wpa3LimitedMoreInfoUrl',
    isBoolean: false,
    isHomepass: true,
    requiredKey: 'wpa3LimitedMoreInfoUrlEnabled',
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    backendKey: 'networkAvailabilityEnabled',
    frontendKey: 'networkAvailabilityEnabled',
    i18nKey: 'networkAvailabilityEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.135.0',
    isAdvanced: true,
  },
  {
    frontendKey: 'contactUsWhatsappNumberEnabled',
    i18nKey: 'contactUsWhatsappNumberEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '>=1.152.0',
    workpassCloudVersionRange: '>=1.152.0',
    isAdvanced: true,
  },
  {
    backendKey: 'contactUsWhatsappNumber',
    frontendKey: 'contactUsWhatsappNumber',
    i18nKey: 'contactUsWhatsappNumber',
    isBoolean: false,
    isHomepass: true,
    isWorkpass: true,
    requiredKey: 'contactUsWhatsappNumberEnabled',
    homepassCloudVersionRange: '>=1.152.0',
    workpassCloudVersionRange: '>=1.152.0',
    isAdvanced: true,
  },
  {
    backendKey: 'deviceSpeedTestEnabled',
    frontendKey: 'deviceSpeedTestEnabled',
    i18nKey: 'deviceSpeedTestEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '>=1.154.0',
    workpassCloudVersionRange: '>=1.154.0',
    isAdvanced: true,
  },
  {
    backendKey: 'appLevelBreakdownEnabled',
    frontendKey: 'appLevelBreakdownEnabled',
    i18nKey: 'appLevelBreakdownEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '>=1.154.0',
    workpassCloudVersionRange: '>=1.154.0',
    isAdvanced: true,
  },
  // {
  //   backendKey: 'advancedOnboardingEnabled',
  //   frontendKey: 'advancedOnboardingEnabled',
  //   i18nKey: 'advancedOnboardingEnabled',
  //   isBoolean: true,
  //   isHomepass: true,
  //   isWorkpass: true,
  //   homepassCloudVersionRange: '>=1.154.0',
  //   workpassCloudVersionRange: '>=1.154.0',
  //   isAdvanced: true,
  // },
  {
    backendKey: 'gatewaySpeedTestEnabled',
    frontendKey: 'gatewaySpeedTestEnabled',
    i18nKey: 'gatewaySpeedTestEnabled',
    isBoolean: true,
    isHomepass: true,
    isWorkpass: true,
    homepassCloudVersionRange: '>=1.123.0',
    workpassCloudVersionRange: '>=1.123.0',
    isAdvanced: true,
  },
  {
    backendKey: 'userFeedbackEnabled',
    frontendKey: 'userFeedbackEnabled',
    i18nKey: 'userFeedbackEnabled',
    isBoolean: true,
    isHomepass: true,
    homepassCloudVersionRange: '>=1.156.0',
    isAdvanced: true,
  },
] as const satisfies DeepReadonly<AppCustomizationField[]>

export type AppCustomizationFieldKey = Extract<
  (typeof appCustomizationAllFieldsSource)[number],
  { frontendKey: string }
>['frontendKey']

type RequiredKeyType = Extract<
  (typeof appCustomizationAllFieldsSource)[number],
  { requiredKey: string }
>['requiredKey']

type BackendKeyType = Extract<
  (typeof appCustomizationAllFieldsSource)[number],
  { backendKey: string }
>['backendKey']

export const appCustomizationAllFields: DeepReadonly<
  Array<
    AppCustomizationField & {
      frontendKey?: AppCustomizationFieldKey
      requiredKey?: RequiredKeyType
      backendKey?: BackendKeyType
    }
  >
> = appCustomizationAllFieldsSource

type IntermediateType<T extends readonly { frontendKey: string; isBoolean: boolean }[]> = {
  [K in T[number] as K['frontendKey']]?: K['isBoolean'] extends true
    ? FieldState<boolean>
    : FieldState<string>
}
export type MobileConfigFormStateType = IntermediateType<typeof appCustomizationAllFieldsSource>

type IntermediateType2<T extends readonly { frontendKey?: string; isBoolean: boolean }[]> = {
  [K in T[number] as K['isBoolean'] extends true
    ? K['frontendKey'] extends string
      ? K['frontendKey']
      : never
    : never]?: K['isBoolean'] extends true ? boolean : string
}
export type AppCustomizationBooleans = keyof IntermediateType2<
  typeof appCustomizationAllFieldsSource
>

type IntermediateType3<T extends readonly { frontendKey?: string; isBoolean: boolean }[]> = {
  [K in T[number] as K['isBoolean'] extends false
    ? K['frontendKey'] extends string
      ? K['frontendKey']
      : never
    : never]?: K['isBoolean'] extends true ? boolean : string
}
export type AppCustomizationStrings = keyof IntermediateType3<
  typeof appCustomizationAllFieldsSource
>

export type CustomRenderStartKey = Extract<
  (typeof appCustomizationAllFieldsSource)[number],
  { customRender: 'start' }
>['frontendKey']

type IntermediateType4<T extends readonly { frontendKey: string; isBoolean: boolean }[]> = {
  [K in T[number] as K['frontendKey']]?: K['isBoolean'] extends true ? boolean : string
}
export type MobileConfigFrontendType = IntermediateType4<typeof appCustomizationAllFieldsSource>

type IntermediateType5<T extends readonly { backendKey?: string; isBoolean: boolean }[]> = {
  [K in T[number] as K['backendKey']]?: K['isBoolean'] extends true ? boolean : string
}
export type MobileConfigBackendType = IntermediateType5<typeof appCustomizationAllFieldsSource>
